<div class="image-container">
  @if (screenshotId) {
    @if (!isImageEditActive) {
      <div class="top-btns">
        @if (shouldShowScrollViewBtn) {
          <div class="fit-btn">
            @if (fitToContainer) {
              <p-button (click)="goToScrollView()" styleClass="p-button-text" icon="true" pTooltip="Go back to scroll view"><fa-icon [icon]="faExpand" [fixedWidth]="true"></fa-icon></p-button>
            } @else {
              <p-button (click)="fitWholeImage()" styleClass="p-button-text" icon="true" pTooltip="Fit whole image"><fa-icon [icon]="faCompress" [fixedWidth]="true"></fa-icon></p-button>
            }
          </div>
        }
        <div class="edit-btn">
          <p-button styleClass="p-button-text" (click)="toggleEditMode()" pTooltip="Edit image" tooltipPosition="top">
            <fa-icon icon="edit"></fa-icon>
          </p-button>
        </div>
      </div>
    }
      @if (isImageEditActive) {
        <wm-imageeditor [data]="getImageEditorData()" [fillContainer]="fitToContainer" (requestToClose)="toggleEditMode()"></wm-imageeditor>
      } @else {
        <div class="editable-image-content">
            <wm-image [downloadable]="true" [imageUrl]="screenshotUrl" [imageId]="screenshotId" [fillContainer]="fitToContainer"></wm-image>
        </div>
      }
  } @else {
    <wm-image [downloadable]="true" [displayMode]="'without_draw_canvas'" [imageUrl]="screenshotUrl" [imageId]="screenshotId" [fillContainer]="true"></wm-image>
  }

</div>
